module.exports = __webpack_public_path__ + "static/media/trophy.47d0bf42.svg";